import { isEmailValid } from '@sky-distribution/validators-common';

export const isValidEmail = (emailAddress: string): boolean => {
  return isEmailValid(emailAddress);
};
